<mat-toolbar color="primary" class="app-toolbar">
  <div class="toolbar-content">
    <a routerLink="/" class="brand">
      <mat-icon class="brand-icon">account_balance</mat-icon>
      <span class="brand-text">German EUDI Ecosystem Sandbox Registrar</span>
    </a>

    <nav class="nav-links">
      @if (authenticated) {
        <a mat-button routerLink="/dashboard" routerLinkActive="active">
          <mat-icon>dashboard</mat-icon>
          Dashboard
        </a>
      }
      <a mat-button routerLink="/catalog" routerLinkActive="active">
        <mat-icon>library_books</mat-icon>
        Catalog
      </a>
      <a
        mat-button
        href="https://bmi.usercontent.opencode.de/eudi-wallet/eidas2/en/ecosystem_knowledge_centre/"
      >
        <mat-icon>school</mat-icon>
        Knowledge Centre
      </a>
    </nav>

    <span class="spacer"></span>

    <div class="user-section">
      @if (!authenticated) {
        <button mat-raised-button (click)="login()">
          <mat-icon>login</mat-icon>
          Sign In
        </button>
      } @else {
        <button
          mat-button
          [matMenuTriggerFor]="userMenu"
          class="user-menu-button"
        >
          <mat-icon>account_circle</mat-icon>
          <span class="username">{{ username }}</span>
          <mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
        </button>
        <mat-menu #userMenu="matMenu">
          <button mat-menu-item disabled>
            <mat-icon>person</mat-icon>
            <span>{{ username }}</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Sign Out</span>
          </button>
        </mat-menu>
      }
    </div>
  </div>
</mat-toolbar>

<main class="app-content">
  <router-outlet></router-outlet>
</main>
